module.exports = __webpack_public_path__ + "img/21.0092aede.png";